import React from 'react';
import styled from 'styled-components';

import { Theme } from '../Theme';
import { FlexRow } from '../Row';

import Hills from './../../../assets/icons/hills.svg';

export const NotFoundDiv = styled.div`
	display: flex;
	flex-direction: column;
	width: auto;
	align-items: center;
	margin: auto 0;
	padding: 1rem;
`;

export const NotFound = styled(({ image = Hills, lines = ['Not Found'] }) => (
	<NotFoundDiv>
		<FlexRow>
			<img
				src={image}
				alt='Not Found'
			/>
		</FlexRow>
		{lines.map((line) => (
			<FlexRow style={{ fontSize: '12px' }}>{line}</FlexRow>
		))}
	</NotFoundDiv>
))``;
